"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDebug = exports.isOnBrowser = exports.getEnv = exports.isOnDevDomain = exports.isGenericDebug = exports.isSilverSurferDebug = exports.isLocalHost = void 0;
function isLocalHost() {
    if (!isOnBrowser()) {
        return false;
    }
    return /^localhost/.test(window.location.hostname) || window.location.hostname === '127.0.0.1';
}
exports.isLocalHost = isLocalHost;
function isSilverSurferDebug() {
    if (!isOnBrowser()) {
        return false;
    }
    return window.location.search.includes('ss_debug');
}
exports.isSilverSurferDebug = isSilverSurferDebug;
function isGenericDebug() {
    if (!isOnBrowser()) {
        return false;
    }
    return window.location.search.includes('debug');
}
exports.isGenericDebug = isGenericDebug;
function isOnDevDomain() {
    if (!isOnBrowser()) {
        return false;
    }
    return /fandom-dev\.(pl|us)$/.test(window.location.hostname);
}
exports.isOnDevDomain = isOnDevDomain;
function getEnv() {
    if (!isOnBrowser()) {
        return 'prod'; // TODO Figure out a way to determine on SSR
    }
    if (isLocalHost() || isOnDevDomain()) {
        return 'dev';
    }
    return 'prod';
}
exports.getEnv = getEnv;
function isOnBrowser() {
    return typeof window !== 'undefined' && !!window['setInterval'];
}
exports.isOnBrowser = isOnBrowser;
function isDebug(override = false) {
    if (override) {
        return override;
    }
    if (!isOnBrowser()) {
        return false; // find a different mechanism
    }
    if (isLocalHost()) {
        return true;
    }
    if (isOnDevDomain()) {
        return true;
    }
    if (isSilverSurferDebug()) {
        return true;
    }
    if (isGenericDebug()) {
        return true;
    }
    return false;
}
exports.isDebug = isDebug;
